import _ from 'lodash';

import DocumentPoint from './models/DocumentPoint';

class DataProcessing {
  static filterDocumentPoints({ sessions = [], documentPoints = [] }) {
    const dataPoints = _.values(documentPoints);
    const allIdeaIds = [];

    for (const session of sessions) {
      for (const idea of session.data.ideas) {
        allIdeaIds.push(idea['_id']);
      }
    }

    return dataPoints.filter(dataPoint => {
      // filter by permissions if dataPoint is type 'idea'
      // leave external sources (TED, EU, Wikipedia, etc.) unfiltered
      if (dataPoint['meta']['source'] === 'idea') {
        return allIdeaIds.indexOf(dataPoint['meta']['idea_id']) >= 0;
      }
      return true;
    });
  }

  static processDocumentData(documentData) {
    return documentData.map(datapoint => new DocumentPoint(datapoint));
  }
}

export default DataProcessing;
